

export const MobilesDeals=[
   'https://www.jiomart.com/images/cms/aw_rbslider/slides/1669784486_Mobile-05.jpg', 
  'https://www.jiomart.com/images/cms/aw_rbslider/slides/1669784519_Mobile-01.jpg',
  'https://www.jiomart.com/images/cms/aw_rbslider/slides/1669784534_Mobile-02.jpg',
  'https://www.jiomart.com/images/cms/aw_rbslider/slides/1669784506_Mobile-03.jpg',

]